import { apiClient } from '@/core/api/client';

/**
 * Public invite resolution — used to pre-fill the signup modal when the user
 * arrives via a care-seeker invitation email (spec Item 6).
 *
 * Endpoint already exists and is public:
 * GET /invites/:inviteId → InvitePublicResponseDto
 */

export type InvitePublicResponse = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  inviterName?: string;
  inviterCompany?: string;
  /** Role of the inviter — modal uses this to skip Screen 2 when an FA invited. */
  inviterRole?: 'FINANCIAL_ADVISOR' | 'SERVICE_PROVIDER';
};

/** Returns null when the invite is not found (404) or invalid (400). */
export const fetchInvitePublic = async (
  inviteId: string,
): Promise<InvitePublicResponse | null> => {
  try {
    const response = await apiClient.get<InvitePublicResponse>(
      `/invites/${encodeURIComponent(inviteId)}`,
    );
    return response.data;
  } catch (err: any) {
    if (err?.statusCode === 404 || err?.statusCode === 400) return null;
    throw err;
  }
};
